import React, { Component } from 'react';
import Logger from '../../utils/logger.js';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    Logger.error('Error caught by boundary:', error, errorInfo);
    this.setState({ errorInfo });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      const { FallbackComponent } = this.props;

      // Use a custom FallbackComponent when provided (e.g. per-page boundaries)
      if (FallbackComponent) {
        return (
          <FallbackComponent error={this.state.error} errorInfo={this.state.errorInfo} onRetry={this.handleRetry} />
        );
      }

      const isSSO =
        this.state.error?.message?.includes('SSO') ||
        this.state.error?.message?.includes('authentication') ||
        this.state.error?.message?.includes('ssoService') ||
        this.state.errorInfo?.componentStack?.includes('SSOService');

      return (
        <div className="error-boundary">
          <div className="error-boundary-content">
            <h2>{isSSO ? 'Authentication Error' : 'Something went wrong'}</h2>
            <p>
              {isSSO
                ? 'There was an issue with automatic sign-in. You can still sign in manually.'
                : 'Please refresh the page or contact support if the problem persists.'}
            </p>
            <div className="error-boundary-actions">
              <button onClick={this.handleRetry} className="retry-button">
                Try Again
              </button>
              <button onClick={() => window.location.reload()} className="reload-button">
                Reload Page
              </button>
            </div>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="error-details" style={{ whiteSpace: 'pre-wrap' }}>
                <summary>Error Details (Development Only)</summary>
                <div>{this.state.error.toString()}</div>
                {this.state.errorInfo?.componentStack && (
                  <div>Component Stack: {this.state.errorInfo.componentStack}</div>
                )}
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
